const isValidatableField = (element) => {
  return Boolean(
    element &&
      typeof element === 'object' &&
      typeof element.setCustomValidity === 'function' &&
      element.validity
  );
};

export const handleLocalizedInvalid = (event, t) => {
  const field = event.target;
  if (!isValidatableField(field)) {
    return;
  }

  field.setCustomValidity('');

  if (field.validity.valueMissing) {
    field.setCustomValidity(t('validation.required'));
    return;
  }

  if (field.validity.typeMismatch) {
    if (field.type === 'email') {
      field.setCustomValidity(t('validation.email'));
      return;
    }
    field.setCustomValidity(t('validation.invalid'));
    return;
  }

  if (field.validity.tooShort) {
    field.setCustomValidity(t('validation.minLength', { min: field.minLength }));
    return;
  }

  if (field.validity.rangeUnderflow) {
    field.setCustomValidity(t('validation.minValue', { min: field.min }));
    return;
  }

  if (field.validity.rangeOverflow) {
    field.setCustomValidity(t('validation.maxValue', { max: field.max }));
    return;
  }

  if (field.validity.patternMismatch) {
    field.setCustomValidity(t('validation.invalidFormat'));
  }
};

export const clearLocalizedInvalid = (event) => {
  const field = event.target;
  if (!isValidatableField(field)) {
    return;
  }
  field.setCustomValidity('');
};
